// Dependencias generales
import React from "react"
import { useEffect, useState } from 'react'
import '../../css/dashboard.css'
import PublicMainHeader from '../../components/AppLayout/PublicMainHeader.js'
import PublicFooter from '../../components/AppLayout/PublicFooter.js'
import PublicAdvisory from "./PublicAdvisory.js"

import '../../css/public.css'

// DASHBOARD
const PublicMain = (params) => {
  
  const [selectedAppOption, setSelectedAppOption] = useState("")  

  useEffect(() => {   
    
    document.body.className = "public"    
    document.getElementById("headerPublico").className = document.getElementById("headerPublico").className.replaceAll(" hidden", "")
    document.documentElement.setAttribute('style','background:#0A0A3B;')    
    document.querySelector('meta[name="theme-color"]').setAttribute("content", "#0A0A3B;");    
    document.title = "HELIAS - Herramientas de asesoramiento"            

    console.log("Base de página pública cargada correctamente.")       

    setSelectedAppOption(<PublicAdvisory selectedOption={params.selectedOption} subOption={params.subOption} setSelectedAppOption={setSelectedAppOption}/>)     
   
  }, [])

  return (    

    <main id="publicMainDiv">      
      
      <PublicMainHeader/>
            
      {selectedAppOption}      

      <PublicFooter/>     

    </main>
  )
}

export default PublicMain